function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun_Megaphone_935860",
  transform: "translate(0.259 0.252)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_115",
  "data-name": "Group 115",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_114",
  "data-name": "Group 114",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_652",
  "data-name": "Path 652",
  d: "M22.21,14.653a.461.461,0,0,0-.77-.148l-4.107,4.469-5.923,2.257a3.224,3.224,0,0,0-1.865,4.16,3.242,3.242,0,0,0,3.013,2.077,3.206,3.206,0,0,0,1.147-.212l.551-.21L17.735,31.3a.461.461,0,0,0,.52.139l2.582-.984a.461.461,0,0,0,.192-.722l-3.284-4.014L19.629,25l6.04.6a.461.461,0,0,0,.477-.623Zm-2.6,9.419a.466.466,0,0,0-.21.028l-2.582.984a.461.461,0,0,0-.192.722l3.284,4.014-1.675.638-3.478-4.251a.461.461,0,0,0-.52-.139l-.861.328a2.287,2.287,0,0,1-.819.152,2.315,2.315,0,0,1-2.152-1.484,2.3,2.3,0,0,1,1.332-2.971l6.025-2.3a.46.46,0,0,0,.175-.119l3.676-4,3.4,8.935Z",
  transform: "translate(-9.333 -11.857)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_653",
  "data-name": "Path 653",
  d: "M19.223,32.722l-1.721.656a.461.461,0,0,0,.328.861l1.721-.656a.461.461,0,0,0-.328-.861Z",
  transform: "translate(-13.58 -21.748)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_654",
  "data-name": "Path 654",
  d: "M48.713,21.6a.46.46,0,0,0-.595-.267l-2.582.984a.461.461,0,1,0,.328.861l2.582-.984A.461.461,0,0,0,48.713,21.6Z",
  transform: "translate(-28.704 -15.602)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_655",
  "data-name": "Path 655",
  d: "M41.952,12.186a.454.454,0,0,0,.188.041.46.46,0,0,0,.42-.272l1.066-2.377a.46.46,0,1,0-.84-.377L41.72,11.578A.46.46,0,0,0,41.952,12.186Z",
  transform: "translate(-26.783 -8.928)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_656",
  "data-name": "Path 656",
  d: "M51.826,33.886l-2.377-1.066a.46.46,0,0,0-.377.84l2.377,1.065a.455.455,0,0,0,.188.041.46.46,0,0,0,.189-.88Z",
  transform: "translate(-30.625 -21.796)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}))));

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.985,
    height: 20.112,
    viewBox: "0 0 21.985 20.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.dab37f25.svg";
export { ForwardRef as ReactComponent };